import diploma1 from '../../../public/diplomas/Masters in Economics and organization of tourism business_page-0001.jpg';
import diploma2 from '../../../public/diplomas/Masters in Economics and organization of tourism business_page-0002.jpg';
import diploma3 from '../../../public/diplomas/Batchelor in Hotel and restaurant organization and management_pages-to-jpg-0001.jpg';
import diploma4 from '../../../public/diplomas/Batchelor in Hotel and restaurant organization and management_pages-to-jpg-0002.jpg';
import diploma5 from '../../../public/diplomas/diploma of higher education_page-0001.jpg';
import diploma6 from '../../../public/diplomas/diploma of higher education_page-0002.jpg';
import diploma7 from '../../../public/diplomas/Certificate for professional qualification from School of technics and electronics_page-0001.jpg';
import diploma8 from '../../../public/diplomas/Certificate for professional qualification from School of technics and electronics_page-0002.jpg';
import diploma9 from '../../../public/diplomas/supplement diploma_page-0001.jpg';
import diploma10 from '../../../public/diplomas/supplement diploma_page-0002.jpg';
import diploma11 from '../../../public/diplomas/supplement diploma_page-0003.jpg';
const diplomaData = [
    
    {
        image: diploma5, alt: 'Masters in Economics and organization in tourism business page 1', date: '02-02-2017'
    },
    {
        image: diploma6, alt: 'Masters in Economics and organization in tourism business page 2', date: '02-02-2017'
    },
    {
        image: diploma1, alt: 'Masters in Economics and organization in tourism business page 3', date: '02-02-2017'
    },
    {
        image: diploma2, alt: 'Masters in Economics and organization in tourism business page 4', date: '02-02-2017'
    },
    {
        image: diploma3, alt: 'Bachelor in Hottel and restaurant organization and managament page 1', date: '15-07-2014'
    },
    {
        image: diploma4, alt: 'Bachelor in Hottel and restaurant organization and managament page 2', date: '15-07-2014'
    },
    
    {
        image: diploma9, alt: 'Bachelor in Hottel and restaurant organization and managament page 3', date: '15-07-2014'
    },
    {
        image: diploma10, alt: 'Bachelor in Hottel and restaurant organization and managament page 4', date: '15-07-2014'
    },
    {
        image: diploma7, alt: 'Leaving cerificate from the school of elecreical engineering and electronics in Bulgaria page 1', date: '02-07-1999'
    },
    {
        image: diploma8, alt: 'Leaving cerificate from the school of elecreical engineering and electronics in Bulgaria page 2', date: '02-07-1999'
    },
]

export default diplomaData;